<template>
  <div class="uradiogroup">
    <div class="uradiogroup__title" :class="{ 'uradiogroup__title_required': required }">{{ title }}</div>
    <div class="uradiogroup__content" role="radiogroup">
      <RadioInput :disabled="disabled" v-for="v in values" :key="v" v-model="val" :name="name" :text="v" :inputvalue="v" :required="required" />
    </div>
  </div>
</template>

<script>
import RadioInput from './RadioInput.vue'
export default {
  components: { RadioInput },
  props: {
    title: { type: String, required: true },
    modelValue: { type: String },
    values: { type: Array, required: true },
    name: { type: String, required: true },
    required: { type: Boolean },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    val: {
      get() {
        return this.modelValue
      },
      set(v) {
        this.$emit('update:modelValue', v)
      },
    }
  }
}
</script>

<style lang="sass" scoped>
.uradiogroup
  margin-bottom: 39px
  &__title
    font-size: 16px
    line-height: 1.25
    color: colors.$gray3
    margin-bottom: 15px
    white-space: break-spaces
    &_required::after
      content: '*'
      color: colors.$newred
      font-weight: 400
      display: inline-block
      transform: translateY(-1px)
  &__content
    display: grid
    grid-gap: 32px 42px
    gap: 32px 42px
    grid-template-columns: auto auto
    justify-content: start
    align-content: start
  @include for-mob
    padding-top: 20px
    &__title
      font-size: 16px
      margin-bottom: 15px
  @include from(350px)
    &__content
      grid-template-columns: auto auto
</style>